import React from 'react'
import Audio from '../Assets/audio/audio.mpeg'
import Axios from 'axios'
import { handleLogout } from "../Utils/auth";
import MasterTemplate from "./MasterTemplate";
import { Link } from 'react-router-dom';

export class SorteioGiro extends React.Component {
    constructor(props) {
        super(props)
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        this.state = {
            user: JSON.parse(localStorage.getItem('user')),
            pedidos: [],
            totalDeCartelasValidas: [],
            gabaritos: [],
            todosGabaritos: [],
            gerentes: [],
            gerenteSelecionado: null,
            count: 0,
            gerentesDoGiro: [],
            cartelaSorteada: {
                codigo: "00000-0"
            },
            codigoSorteado: [0, 0, 0, 0, 0, '-', 0],
            managerSelected: false,
            gerenteIndex: localStorage.getItem("gerenteIndex") ? parseInt(localStorage.getItem("gerenteIndex")) : 0
        }
        this.selecionarCartela = this.selecionarCartela.bind(this)
        this.init()
    }

    init() {
        this.getGerentesDoGiro();
        this.getTodosGabaritos()
        this.getGabaritos();
    }

    async updateGerentesDoGiro(gerentesDoGiro) {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("parametros/update-gerentes-giro", { gerentesDoGiro: gerentesDoGiro });
            this.setState({ gerentesDoGiro: gerentesDoGiro });
        } catch (err) {
            console.log(err);
        }
    };


    updateGerenteList(index) {
        this.state.gerentesDoGiro.splice(parseInt(index), 1);
        this.updateGerentesDoGiro(this.state.gerentesDoGiro);
    }


    async getGerentesDoGiro() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/get-gerentes-giro");
            this.setState({ gerentesDoGiro: response.data.gerentesDoGiro });
            var index = Math.floor(Math.random() * this.state.gerentesDoGiro.length)
            this.setGerente(this.state.gerentesDoGiro[index]);
            localStorage.setItem('currentGerenteGiro', index);


        } catch (err) {
            console.log(err);
        }
    };

    setGerente(gerenteId) {
        this.setState({ gerenteSelecionado: gerenteId })
        this.getPedidosPorGerente(gerenteId);
    }



    async getTodosGabaritos() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabaritos-ativos");
            this.setState({ todosGabaritos: response.data });
        } catch (err) {
            console.log(err);
        }
    }

    criarGabarito = async (vencedor) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("gabaritos/criar-gabarito", { ...vencedor });
            this.intervalo()
            this.nextGerente()
        } catch (err) {
            console.log(err);
        }
    };

    getPedidos = async e => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("pedidos/pedidos-giro");
            this.setState({ pedidos: response.data })
            this.obterTotalDeCartelas()
            if (this.state.pedidos.length <= 0) {
                alert("Não existem cartelas validadas");
            }
        } catch (err) {
            console.log(err)
        }
    }

    async getPedidosPorGerente(gerenteSelecionado) {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("pedidos/pedidos-giro-por-gerente", { gerenteId: gerenteSelecionado });
            this.setState({ pedidos: response.data })

            this.obterTotalDeCartelas()
            if (this.state.pedidos.length <= 0) {
                this.nextGerente()
            }

        } catch (err) {
            console.log(err)
        }
    }

    nextGerente() {
        this.state.totalDeCartelasValidas = [];
        this.setState({ totalDeCartelasValidas: [] });
        this.getGerentesDoGiro()
    }

    getGabaritos = async e => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabarito-giro-atuais");
            this.setState({ gabaritos: response.data })
        } catch (err) {
            console.log(err)
        }
    }

    reversaOrdem(array) {
        var arrayFinal = [];
        if (array !== null) {
            for (var i = (array.length - 1); i >= 0; i--) {
                arrayFinal.push(array[i]);
            }
        }
        return arrayFinal;
    }

    obterTotalDeCartelas() {
        this.state.pedidos.map(pedido => {
            this.state.totalDeCartelasValidas = this.concatenarArrays(this.state.totalDeCartelasValidas, pedido.cartelas)
        })
        this.setState({ ...this.state })
    }


    concatenarArrays(arrayFinal, array) {
        array.map(elemento => {
            if (elemento.codigo[6] != '0') {
                arrayFinal.push(elemento);
            }
        })
        return arrayFinal;
    }

    retornarPedidoPorCartela(cartelaSorteada) {
        let pedidoEncontrado = null
        this.state.pedidos.map(pedido => {
            pedido.cartelas.map(cartela => {
                if (cartela.codigo == cartelaSorteada.codigo)
                    pedidoEncontrado = pedido;
            })
        })
        return pedidoEncontrado;
    }


    selecionarCartela() {
        if (this.state.pedidos.length > 0) {
            var sorteada = this.state.cartelaSorteada;
            if (this.state.totalDeCartelasValidas.length > 0) {
                let currentGerenteId = this.state.gerentesDoGiro[localStorage.getItem('currentGerenteGiro')];
                    sorteada = this.state.totalDeCartelasValidas[Math.floor(Math.random() * this.state.totalDeCartelasValidas.length)]
                if (sorteada.codigo != "00000-0" && !this.contemCartela(sorteada)) {
                    this.setState({ cartelaSorteada: sorteada })
                    var pedido = this.retornarPedidoPorCartela(sorteada)
                    if(pedido){
                        document.getElementById("myAudio").play()
                        var vencedor = {
                            tipo: 'Sorteio Giro',
                            cartelaSorteada: sorteada,
                            ganhadorId: pedido.clienteId,
                            cambistaId: pedido.cambistaId,
                            gerenteId: pedido.gerenteId,
                            status: true,
                            masterId: this.state.user._id,
                            obsPremio: "Conferir com a Banca"
                        }
                        this.criarGabarito(vencedor)
                        this.updateGerenteList(localStorage.getItem('currentGerenteGiro'))
                    }
                }
            }
            else {
                alert("Atualizar!")
            }
        }


    }

    contemCartela(cartela) {
        var contem = true;
        if (cartela.codigo)
            contem = this.state.todosGabaritos.some(gabarito => gabarito.cartelaSorteada.codigo == cartela.codigo)
        return contem;
    }

    intervalo() {
        var index = 6;
        var intervalo = setInterval(() => {
            if (index < 0) {
                clearInterval(intervalo);
                this.getTodosGabaritos()
                this.getGabaritos()
            }
            if (this.state.cartelaSorteada.codigo[index] == '-') {
                index -= 1;
            }
            else {
                var codigo = this.state.codigoSorteado[index];
                codigo = Math.floor(Math.random() * 10);
                this.state.codigoSorteado[index] = codigo;
                this.setState({ codigoSorteado: this.state.codigoSorteado })
                if (this.state.codigoSorteado[index] == this.state.cartelaSorteada.codigo[index])
                    index -= 1;
            }


        }, 100);
    }

    render() {
        return (
            <MasterTemplate label="Giro de prêmios!">
                <audio id="myAudio">
                    <source src={Audio} type="audio/mpeg" />
                </audio>
                <div class="container-fluid">
                    <div class='container'>

                        <div class="row">
                            <Link class="ml-3 btn-fill btn btn-danger bts-giro" to="/sorteio" ><i class="fa fa-arrow-left" aria-hidden="true"></i>Voltar</Link>
                            <div className="select-managers">
                                <input className="collapse ml-5" disabled value={this.state.gerentes.length > 0 ? this.state.gerentes[this.state.gerenteIndex ? this.state.gerenteIndex : 0]?.nome : 'vazio'}></input>
                                <button class=" collapse ml-1 btn-fill btn btn-warning bts-giro" onClick={() => window.location.reload()} >Proximo</button>
                            </div>
                        </div>
                    </div>
                    <div className="margin-giro row">
                        <button class="ml-4 btn-fill btn btn-success bts-giro" disabled={this.state.totalDeCartelasValidas.length == 0} onClick={this.selecionarCartela}><i class="fas fa-dice"></i> GIRAR</button>
                    </div>
                    <div class="mt-3 row justify-content-center">
                        <div class="ml-5 " >
                            <div class="bg-white border text-center" style={{ width: '4em', height: '4em' }}>
                                <h2 class="mt-3">{this.state.gabaritos.length}º</h2>
                            </div>
                        </div>
                        <div class="ml-5 d-flex justify-content-start text-danger" style={{ pedding: '0px !important', margin: '0px !important' }}>
                            <div class="bg-dark border border-danger text-center" style={{ width: '4em', height: '4em' }}>
                                <h2 class="mt-3" >{this.state.codigoSorteado[0]}</h2>
                            </div>
                            <div class="bg-dark border border-danger text-center" style={{ width: '4em', height: '4em' }}>
                                <h2 class="mt-3">{this.state.codigoSorteado[1]}</h2>
                            </div>
                            <div class="bg-dark border border-danger text-center" style={{ width: '4em', height: '4em' }}>
                                <h2 class="mt-3">{this.state.codigoSorteado[2]}</h2>
                            </div>
                            <div class="bg-dark border border-danger text-center" style={{ width: '4em', height: '4em' }}>
                                <h2 class="mt-3">{this.state.codigoSorteado[3]}</h2>
                            </div>
                            <div class="bg-dark border border-danger text-center" style={{ width: '4em', height: '4em' }}>
                                <h2 class="mt-3">{this.state.codigoSorteado[4]}</h2>
                            </div>
                            <div class="bg-dark border border-danger text-center" style={{ width: '4em', height: '4em' }}>
                                <h2 class="mt-3">{this.state.codigoSorteado[5]}</h2>
                            </div>
                            <div class="bg-dark border border-danger text-center" style={{ width: '4em', height: '4em' }}>
                                <h2 class="mt-3">{this.state.codigoSorteado[6]}</h2>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5 justify-content-center">
                        <table class="ml-5 table" style={{ maxWidth: '50em' }}>
                            <thead class="bg-dark thead-dark">
                                <tr>
                                    <th scope="col">No.</th>
                                    <th scope="col"> Cartela___  </th>
                                    <th scope="col">Ganhador</th>
                                    <th scope="col">Vendedor</th>
                                    <th scope="col">Endereço</th>
                                    <th scope="col">Regional</th>
                                </tr>
                            </thead>
                            <tbody>

                                {this.state.gabaritos.length > 0 ? this.reversaOrdem(this.state.gabaritos).map((gabarito, index) => {

                                    return (<tr>
                                        <th scope="row">{this.state.gabaritos.indexOf(gabarito) + 1}</th>
                                        <td>{gabarito.cartelaSorteada.codigo}</td>
                                        <td>{gabarito.ganhadorId ? gabarito.ganhadorId.nome : ""}</td>
                                        <td>{gabarito.cambistaId ? gabarito.cambistaId.nome == 'Aplicativo' ? "Sorteflash App 2.0" : gabarito.cambistaId.nome : ""}</td>
                                        <td>{gabarito.ganhadorId ? gabarito.ganhadorId.cidade + " - " + gabarito.ganhadorId.estado : "Não preenchido :("}</td>
                                        <td>{gabarito.gerenteId ? gabarito.gerenteId.bairro ? gabarito.gerenteId.nome : "Não preenchido :(" : "Desconhecido"}</td>
                                    </tr>)

                                }) : ""}

                            </tbody>
                        </table>
                    </div>
                </div>
            </MasterTemplate>
        )
    }
}

export default SorteioGiro
